export const DEFAULT_SHADOW_BORDER_COLOR = { rgb: { r: 0, g: 0, b: 0, a: 1 }, hex: '#000000' };
